module.exports = __webpack_public_path__ + "static/media/mindfulness-for-financial-stress-large@3x.16a1aa3d.png";